import {getAPIbaseURL} from "@/api/config/init";

const prex = `${getAPIbaseURL()}/relatorio/financeiro/`;

export function getFinanceiroGuia(dam_hash) {
    return `${prex}guia/${dam_hash}`;
}

export function getFinanceiroComprovante(dam_hash) {
    return `${prex}comprovante/${dam_hash}`;
}